import { all } from '@freightview/holidays'

import { SystemNotifications as BaseSystemNotifications } from '@fv/client-components'
import { fvDate, fvDateUtc } from '@fv/dates'
import type { SystemNotification } from '@fv/models'
import type { DTO } from '@fv/models/core'

import { useAppContext } from '@/hooks/settings/useAppContext'

import { useRole } from '../auth/hooks'
import { useProvisionedAccountCarriers } from '../carrier-network/queries'
import { getHolidayMessage } from './holidayMessage'
import { useSystemNotifications } from './queries'

export const SystemNotifications = () => {
  const role = useRole()
  const { data: contextData } = useAppContext()
  const carriersQuery = useProvisionedAccountCarriers()
  const notificationsQuery = useSystemNotifications()

  const carrierIds = carriersQuery.data?.map(c => c.carrierId) ?? []
  const today = fvDate()
  const holidaysToShow = all()
    .filter(h =>
      h.observed.some(d => {
        const day = fvDateUtc(d)
        return (
          today.isAfter(day.subtract(7, 'days'), 'day') &&
          today.isBefore(day.add(1, 'days'), 'day')
        )
      }),
    )
    .map<DTO<SystemNotification>>(holiday => ({
      _id: `holiday-${holiday.key}-${today.format('YYYY')}`,
      expiration: today.add(7, 'days').toISOString(),
      text: getHolidayMessage(holiday),
      type: 'holiday',
    }))

  const notificationsForRole =
    notificationsQuery.data?.filter(
      n => !n.userType?.length || n.userType.includes(role),
    ) ?? []

  const relevantNotifications = notificationsForRole
    .filter(n => !n.carrierId || carrierIds.includes(n.carrierId))
    .concat(holidaysToShow)

  return (
    <BaseSystemNotifications
      notifications={relevantNotifications}
      canDismissEnvironmentBanner={contextData?.user?.isAdmin}
    />
  )
}
